import React, { Component } from "react";
import TextField from "./TextField";
import SearchField from "./SearchField";
import DateRangePicker from "react-bootstrap-daterangepicker";
import moment from "moment";
import "bootstrap-daterangepicker/daterangepicker.css";
import Style from "style-it";
import { connect } from "react-redux";

// 3 calendar days = start + 2 days (maxSpan). Stable ref so picker updates don't drop maxSpan.
const DLOGS_DATE_LIMIT = Object.freeze({ days: 2 });

class CustomDateRangePicker extends Component {
  ensureDlogsMaxSpan = (event, picker) => {
    if (this.props.dlogs && picker) {
      picker.maxSpan = DLOGS_DATE_LIMIT;
    }
    if (typeof this.props.onEvent === "function") {
      this.props.onEvent(event, picker);
    }
  };

  render() {
    const {
      themecolors,
      fill,
      dlogs,
      selectedDate,
      label,
      error,
      children,
      customPicker,
      futureDates,
      datepickerOnly,
      ranges: userRanges,
      dateLimit: userDateLimit,
      onEvent,
      onApply,
      onCancel,
      onShow,
      onHide,
      dispatch,
      ...pickerPassThrough
    } = this.props;

    const rangesFuture = {
      Today: [moment().startOf("day"), moment().endOf("day")],
      "Next 7 Days": [
        moment().endOf("day"),
        moment().add(7, "days").endOf("day"),
      ],
      "Next 30 Days": [
        moment().endOf("day"),
        moment().add(30, "days").endOf("day"),
      ],
      "This Month": [
        moment().startOf("month").startOf("day"),
        moment().endOf("month").endOf("day"),
      ],
      "Next Month": [
        moment().add(1, "month").startOf("month").startOf("day"),
        moment().add(1, "month").endOf("month").endOf("day"),
      ],
    };
    const ranges = {
      Today: [moment().startOf("day"), moment().endOf("day")],
      Yesterday: [
        moment().subtract(1, "days").startOf("day"),
        moment().subtract(1, "days").endOf("day"),
      ],
      "Last 7 Days": [
        moment().subtract(7, "days").startOf("day"),
        moment().startOf("day"),
      ],
      "Last 30 Days": [
        moment().subtract(30, "days").startOf("day"),
        moment().startOf("day"),
      ],
      "This Month": [
        moment().startOf("month").startOf("day"),
        moment().endOf("month").endOf("day"),
      ],
      "Last Month": [
        moment().subtract(1, "month").startOf("month").startOf("day"),
        moment().subtract(1, "month").endOf("month").endOf("day"),
      ],
    };

    const dlogsRanges = {
      Today: [moment().startOf("day"), moment().endOf("day")],
      Yesterday: [
        moment().subtract(1, "days").startOf("day"),
        moment().subtract(1, "days").endOf("day"),
      ],
      "Last 3 Days": [
        moment().subtract(2, "days").startOf("day"),
        moment().endOf("day"),
      ],
    };
    if (this.props.customPicker) {
      return (
        <>
          <Style>
            {`
          .daterangepicker td.in-range {
            background: ${this.props.themecolors[100]};
          }
          .daterangepicker td.active, .daterangepicker td.active:hover,
          .daterangepicker .ranges li.active,
          .daterangepicker .ranges li:hover {
            background: ${this.props.themecolors.themeLightColor};
            color: ${this.props.themecolors.themeLightInverse};
          }
          `}
          </Style>
          <DateRangePicker
            containerStyles={{}}
            {...this.props}
            ranges={
              this.props.futureDates
                ? rangesFuture
                : this.props.ranges || ranges
            }
            timePicker={this.props.datepickerOnly !== false}
            timePicker24Hour={this.props.datepickerOnly !== false}
          >
            {this.props.children}
          </DateRangePicker>
        </>
      );
    } else if (this.props.fill) {
      return (
        <>
          <Style>
            {`
            .daterangepicker td.in-range {
               background: ${themecolors[100]};
            }
            .daterangepicker td.active, .daterangepicker td.active:hover,
            .daterangepicker .ranges li.active {
               background: ${themecolors.themeLightColor};
               color: ${themecolors.themeLightInverse};
            }
            `}
          </Style>
          <DateRangePicker
            containerStyles={{}}
            {...pickerPassThrough}
            ranges={
              futureDates
                ? rangesFuture
                : dlogs
                ? dlogsRanges
                : userRanges || ranges
            }
            dateLimit={dlogs ? userDateLimit || DLOGS_DATE_LIMIT : userDateLimit}
            timePicker={datepickerOnly !== false}
            timePicker24Hour={datepickerOnly !== false}
            onEvent={dlogs ? this.ensureDlogsMaxSpan : onEvent}
            onApply={onApply}
            onCancel={onCancel}
            onShow={onShow}
            onHide={onHide}
          >
            <SearchField
              error={error}
              fullWidth
              margin="dense"
              label={label}
              value={selectedDate}
            />
          </DateRangePicker>
        </>
      );
    } else {
      return (
        <>
          <Style>
            {`
            .daterangepicker td.in-range {
               background: ${this.props.themecolors[100]};
            }
            .daterangepicker td.active, .daterangepicker td.active:hover,
            .daterangepicker .ranges li.active {
               background: ${this.props.themecolors.backgroundColor};
               color: ${this.props.themecolors.textColor};
            }
            `}
          </Style>

          <DateRangePicker
            containerStyles={{}}
            {...this.props}
            ranges={
              this.props.futureDates
                ? rangesFuture
                : this.props.ranges || ranges
            }
            timePicker={this.props.datepickerOnly !== false}
            timePicker24Hour={this.props.datepickerOnly !== false}
          >
            <TextField
              fullWidth
              error={this.props.error}
              margin="dense"
              label={this.props.label || "Select Date"}
              value={this.props.selectedDate}
            />
          </DateRangePicker>
        </>
      );
    }
  }
}

const mapStateToProps = (state) => ({
  themecolors: state.themeColors,
});

export default connect(mapStateToProps)(CustomDateRangePicker);
